class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }
  handleSticky() {
    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;

    let lastScroll = 0;
    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;
      if (currentScroll <= extraSpace) {
        this.classList.remove(this.classes.scrollUp, this.classes.stuck, this.classes.always);
        document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
        return;
      }

      if (this.stickyHeader === "on_scroll_up") {
        this.classList.add(this.classes.stuck);
      } else if (this.stickyHeader === "always") {
        this.classList.add(this.classes.always);
      }

      if (
        currentScroll > this.headerHeight + extraSpace &&
        currentScroll > lastScroll &&
        !this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollUp);
        document.body.classList.remove(this.classes.headerScrollUp);
        this.classList.add(this.classes.scrollDown);
        document.body.classList.add(this.classes.headerScrollDown);
      } else if (currentScroll < lastScroll && this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);
        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }
      lastScroll = currentScroll;
    });
  }
}

// SiteNav class for mobile menu functionality
class SiteNav {
  constructor(header) {
    this.header = header;
    this.menuDrawer = document.getElementById('m-menu-drawer');
    this.hamburgerButton = this.header.querySelector('.m-hamburger-box');
    this.isOpen = false;
    
    console.log('SiteNav initialized:', {
      header: this.header,
      menuDrawer: this.menuDrawer,
      hamburgerButton: this.hamburgerButton
    });
    
    this.init();
  }

  init() {
    if (this.hamburgerButton) {
      console.log('Adding click listener to hamburger button');
      this.hamburgerButton.addEventListener('click', (e) => {
        e.preventDefault();
        console.log('Hamburger button clicked');
        this.toggleMenu();
      });
    } else {
      console.error('Hamburger button not found');
    }

    // Close menu when clicking on backdrop
    if (this.menuDrawer) {
      const backdrop = this.menuDrawer.querySelector('.m-menu-drawer__backdrop');
      if (backdrop) {
        backdrop.addEventListener('click', () => {
          console.log('Backdrop clicked, closing menu');
          this.closeMenu();
        });
      }
    } else {
      console.error('Menu drawer not found');
    }

    // Handle submenu toggles
    this.handleSubmenuToggles();
  }

  toggleMenu() {
    console.log('Toggle menu called, current state:', this.isOpen);
    if (this.isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    console.log('Opening menu');
    if (this.menuDrawer && this.hamburgerButton) {
      this.menuDrawer.classList.add('open');
      this.hamburgerButton.classList.add('active');
      this.header.classList.add('header-drawer-open');
      document.body.classList.add('m:overflow-hidden');
      this.isOpen = true;
      console.log('Menu opened successfully');
    } else {
      console.error('Cannot open menu - missing elements');
    }
  }

  closeMenu() {
    console.log('Closing menu');
    if (this.menuDrawer && this.hamburgerButton) {
      this.menuDrawer.classList.remove('open');
      this.hamburgerButton.classList.remove('active');
      this.header.classList.remove('header-drawer-open');
      document.body.classList.remove('m:overflow-hidden');
      this.isOpen = false;
      console.log('Menu closed successfully');
    } else {
      console.error('Cannot close menu - missing elements');
    }
  }

  handleSubmenuToggles() {
    if (this.menuDrawer) {
      // Handle submenu toggle buttons
      const toggleButtons = this.menuDrawer.querySelectorAll('[data-toggle-submenu]');
      console.log('Found submenu toggle buttons:', toggleButtons.length);
      toggleButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const level = button.getAttribute('data-toggle-submenu');
          const submenu = button.nextElementSibling;
          
          if (submenu && submenu.classList.contains('m-megamenu-mobile')) {
            submenu.classList.add('open-submenu');
            console.log('Submenu opened for level:', level);
          }
        });
      });

      // Handle back buttons
      const backButtons = this.menuDrawer.querySelectorAll('.m-menu-mobile__back-button');
      console.log('Found back buttons:', backButtons.length);
      backButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const submenu = button.closest('.m-megamenu-mobile');
          if (submenu) {
            submenu.classList.remove('open-submenu');
            console.log('Submenu closed');
          }
        });
      });
    }
  }
}

// Megamenu class for desktop mega menu functionality
class Megamenu {
  constructor(header) {
    this.header = header;
    this.init();
  }

  init() {
    // Basic mega menu functionality can be added here if needed
    // For now, this is just a placeholder to prevent errors
  }
}

customElements.define("m-header", MHeader);
